'use strict';

const $ = (window.jQuery = window.$ = require('jquery'));

/* Standard Slider */
var SwiperLib = require('swiper');
var Swiper = SwiperLib.default || SwiperLib;
var Pagination = SwiperLib.Pagination;

var mosaicGridOptions = {
    speed: 400,
    spaceBetween: 10,
    modules: [Pagination],
    slidesPerView: 1
};

/* Standard Slider */
var standardSlider = function() {
    if ($('.standard-slider').length > 0) {
        if ($('.standard-slider .slick-slide').length == 0) {
            $('.standard-slider').each(function() {
                var slidesContainer = $(this);

                var $currentSlide = $(this)
                    .parent()
                    .find('.content-number-slide .current-number');
                var $totalSlide = $(this)
                    .parent()
                    .find('.content-number-slide .total-number');
                var $slickElement = $(this);

                $slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
                    var i = 0;

                    if (slick.slideCount > 1) {
                        i = (currentSlide ? currentSlide : 0) + 1;
                        $currentSlide.text('0' + i);
                    } else {
                        i = 0;
                        $currentSlide.closest('.content-number-slide').hide();
                    }

                    //$totalSlide.text(slick.slideCount);
                });

                slidesContainer.slick({
                    infinite: true,
                    autoplay: false,
                    focusOnSelect: true,
                    centerMode: false,
                    autoplaySpeed: 3000,
                    speed: 500,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    variableWidth: false,
                    dots: true
                });
            });
        }
    }
};

/* Simple Slider */
var simpleSlider = function() {
    if ($('.simple-slider').length > 0) {
        if ($('.simple-slider .slick-slide').length == 0) {
            $('.simple-slider').each(function() {
                var slidesContainer = $(this);

                slidesContainer.slick({
                    infinite: false,
                    autoplay: false,
                    focusOnSelect: true,
                    centerMode: false,
                    autoplaySpeed: 3000,
                    speed: 500,
                    slidesToScroll: 1,
                    slidesToShow: 4,
                    variableWidth: false,
                    dots: true,
                    prevArrow: false,
                    nextArrow: false,
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 543,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                    ]
                });
            });
        }
    }
};

/* Selected Boxes Slider */
var selectedBoxesSlider = function() {
    if ($('.selected-boxes-slider').length > 0) {
        if ($('.selected-boxes-slider .slick-slide').length == 0) {
            $('.selected-boxes-slider').each(function() {
                var slidesContainer = $(this);

                slidesContainer.slick({
                    infinite: false,
                    autoplay: false,
                    focusOnSelect: true,
                    centerMode: false,
                    autoplaySpeed: 3000,
                    speed: 500,
                    slidesToScroll: 1,
                    slidesToShow: 3,
                    variableWidth: false,
                    dots: true,
                    prevArrow: false,
                    nextArrow: false,
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                    ]
                });
            });
        }
    }
};

var recaptchaManualInit = function() {
    if ($('#g-recaptcha-init').length) {
        var sitekey = $('.grec-info').data('skey');
        grecaptcha.render('g-recaptcha-init', { "sitekey": sitekey });
    }
};

/* Mosaic Grid Slider (mobile) */
var mosaicGridSlider = function() {
    var isMobile = window.matchMedia('(max-width: 575px)').matches;

    $('.js-mosaic-grid').each(function() {
        var swiperInstance = this.swiper;

        if (!isMobile) {
            if (swiperInstance) {
                swiperInstance.destroy(true, true);
            }
            return;
        }

        if (swiperInstance) {
            swiperInstance.update();
            return;
        }

        var paginationEl = $(this)
            .find('.swiper-pagination')
            .get(0);

        if (!paginationEl) {
            return;
        }

        new Swiper(this, Object.assign({}, mosaicGridOptions, {
            pagination: {
                el: paginationEl,
                type: 'bullets',
                clickable: true
            }
        }));
    });
};

/* Simple Arrow Slider (Carousel Slider – Layout Ridotto) */
var simpleArrowSlider = function() {
    if ($('.simple-arrow-slider').length > 0) {
        if ($('.simple-arrow-slider .slick-slide').length == 0) {
            $('.simple-arrow-slider').each(function() {
                $(this).slick({
                    infinite: false,
                    autoplay: false,
                    focusOnSelect: true,
                    centerMode: false,
                    speed: 400,
                    slidesToScroll: 1,
                    slidesToShow: 4,
                    variableWidth: false,
                    dots: true,
                    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"></button>',
                    nextArrow: '<button type="button" class="slick-next" aria-label="Next"></button>',
                    responsive: [
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 2.5
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1.5
                            }
                        }
                    ]
                });
            });
        }
    }
};

$(document).ready(function() {
    standardSlider();
    simpleSlider();
    simpleArrowSlider();
    selectedBoxesSlider();
    mosaicGridSlider();
    $(window).on('resize orientationchange', mosaicGridSlider);
    // eslint-disable-next-line sonarjs/no-use-of-empty-return-value


    // USER TYPE
    $(document).on('click', '.content-user-type .user-type', function() {
        $(this)
            .siblings()
            .removeClass('active');
        $(this).addClass('active');

        if ($(this).hasClass('user-type-agency')) {
            $(this)
                .closest('.login-form-nav')
                .find('.content-for-agency')
                .show();
            $(this)
                .closest('.login-form-nav')
                .addClass('login-form-nav--agency');
        } else {
            $(this)
                .closest('.login-form-nav')
                .find('.content-for-agency')
                .hide();
            $(this)
                .closest('.login-form-nav')
                .removeClass('login-form-nav--agency');
        }
    });

    // SEARCH DESKTOP
    $('.link-search').on('click', function() {
        let searchMain = $('.content-search-space');
        let searchAgency = $('.content-search-agency');
        let isDesktop = window.matchMedia('(min-width: 992px)').matches;
        let isNewMegamenuEnabled = $('header[data-component="Header"]').hasClass('new-megamenu-enabled');
        let useMobileSearchPanel = !isDesktop && isNewMegamenuEnabled;
        let $panel = useMobileSearchPanel ? $('header .search-mobile .site-search') : $('header .search-desktop .site-search');

        if (!useMobileSearchPanel) {
            $panel.fadeIn('300');
        } else {
            if (!$panel.hasClass('show')) {
                $panel.data('body-no-scroll-before-search', $('body').hasClass('body-no-scroll'));
                $panel.data('menu-toggle-opened-before-search', $('.navbar-toggler').hasClass('opened'));
            }
            $panel.addClass('show');
            $('.navbar-toggler').addClass('opened');
        }
        $('body').addClass('body-no-scroll');
        if ($(this).hasClass('link-changeAgency')) {
            searchMain.hide();
            searchAgency.show();
            $panel.find('.search-field').focus();
        } else {
            searchMain.show();
            searchAgency.hide();
            $panel.find('.search-field').focus();
        }
    });
    $('header .search-desktop .site-search .site-search-close, header .search-mobile .site-search .site-search-close').on('click', function() {
        let $panel = $(this).closest('.site-search');
        let isMobile = window.matchMedia('(max-width: 991.98px)').matches;
        let isNewMegamenuEnabled = $('header[data-component="Header"]').hasClass('new-megamenu-enabled');
        if (!isMobile || !isNewMegamenuEnabled) {
            $('header .search-desktop .site-search').fadeOut('300');
            $('body').removeClass('body-no-scroll');
        } else {
            $panel.removeClass('show');
            if (!$panel.data('body-no-scroll-before-search')) {
                $('body').removeClass('body-no-scroll');
            }
            $('.navbar-toggler').toggleClass('opened', !!$panel.data('menu-toggle-opened-before-search'));
        }
    });
});

window.onloadCallback = function() {
    recaptchaManualInit();
};

jQuery.event.special.touchstart = {
    setup: function(_, ns, handle) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function(_, ns, handle) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function(_, ns, handle) {
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function(_, ns, handle) {
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};
